export default __webpack_public_path__ + "static/15_agro-a50323358442a4bcc2ad4cec8cf0ab1d.png";